export const TABS = {
  ACCOUNT: "Account",
  FEEDBACKS: "Feedbacks",
};
